export const getFormattedLabel = (label) => {
  switch (label) {
    case 'inapp':
      return 'In-App'
    case 'whatsapp':
      return 'WhatsApp'
    case 'sms':
      return 'SMS'
    case 'email':
      return 'Email'
    case 'push':
      return 'Push'
    case 'webpush':
      return 'WebPush'
    case 'slack':
      return 'Slack'
    case 'discord':
      return 'Discord'
    case 'teams':
      return 'Teams'
    case 'voice':
      return 'Voice'
  }
}

export const getPanelWidth = (lgUp, smUp) => {
  if (lgUp) {
    return '29vw'
  } else if (smUp) {
    return '64vw'
  } else {
    return '85vw'
  }
}

export const hexToRGBA = (hexCode, opacity) => {
  let hex = hexCode?.replace('#', '')
  if (hex?.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
  }
  const r = parseInt(hex?.substring(0, 2), 16)
  const g = parseInt(hex?.substring(2, 4), 16)
  const b = parseInt(hex?.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export const sanitizeHtml = (html) => {
  const safeTags = [
    'p',
    'br',
    'b',
    'i',
    's',
    'u',
    'strong',
    'em',
    'a',
    'tt',
    'span',
    'div',
    'code',
    'pre',
    'ul',
    'ol',
    'li',
    'blockquote',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
  ]

  const safeProtocols = ['http:', 'https:', 'mailto:', 'tel:']

  return html.replace(
    /<\/?([a-z0-9]+)(\s[^>]*)?>/gi,
    (match, tagName, attrs) => {
      tagName = tagName.toLowerCase()

      if (safeTags.includes(tagName)) {
        return match
      }

      if (tagName === 'a') {
        const hrefMatch = /href\s*=\s*["']([^"']+)["']/i.exec(attrs || '')
        const href = hrefMatch?.[1]
        try {
          const url = new URL(href, 'https://dummy.com')
          if (safeProtocols.includes(url.protocol)) {
            return `<a href="${url.href}">`
          }
        } catch (error) {
          console.error(error)
          return '&lt;a&gt;'
        }
      }

      // Not a safe tag — escape it
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }
  )
}

export const generateBodyPreview = (value, list) => {
  if (value) {
    let preview_val = value
    for (const key in list) {
      const regex = new RegExp(key, list[key]?.scope)
      preview_val =
        typeof preview_val === 'string'
          ? preview_val?.replace(regex, list[key]?.with)
          : preview_val?.map((item) => {
              return item?.replace(regex, list[key]?.with)
            })
    }

    const tt_regex =
      /(<tt style="word-wrap: break-word; white-space: pre-wrap; word-break: break-word;">(?:\n|.)+?<\/tt>)/gm

    let m
    const replace = []
    const replace_with = []

    while ((m = tt_regex.exec(preview_val)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === tt_regex.lastIndex) {
        tt_regex.lastIndex++
      }

      const replace_with_temp = m[0]
        .replace(/<i>|<\/i>?/gm, '_')
        .replace(/<b>|<\/b>?/gm, '*')
        .replace(/<s>|<\/s>?/gm, '~')

      if (m[0] !== replace_with_temp) {
        replace.push(m[0])
        replace_with.push(replace_with_temp)
      }
    }
    for (let i = 0; i < replace?.length; i++) {
      preview_val = preview_val.replace(replace[i], replace_with[i])
    }
    return sanitizeHtml(preview_val)
  } else {
    return ''
  }
}

export const regexList = {
  '&': {
    scope: 'g',
    with: '&amp;'
  },
  '"': {
    scope: 'g',
    with: '&quot;'
  },
  '\n': {
    scope: 'g',
    with: '<br/>'
  },
  '\\*(\\S(?:.*?)\\S|\\S)\\*': {
    scope: 'g',
    with: '<b>$1</b>'
  },
  '\\b_(\\S(?:.*?)\\S|\\S)_\\b': {
    scope: 'g',
    with: '<i>$1</i>'
  },
  '~(\\S(?:.*?)\\S|\\S)~': {
    scope: 'g',
    with: '<s>$1</s>'
  },
  '```((?:\\n|.)*?)```': {
    scope: 'gm',
    with: '<tt style="word-wrap: break-word; white-space: pre-wrap; word-break: break-word;">$1</tt>'
  }
}
